import { createContext, useContext } from "react";
import type { IFavouritesProviderContextValue } from "./FavouritesProvider.types";

export const FavouritesProviderContext = createContext<IFavouritesProviderContextValue>({} as IFavouritesProviderContextValue);

export function useFavouritesProviderContext() {
  return useContext(FavouritesProviderContext);
}
